// extracted by mini-css-extract-plugin
export default {"qrCode":"QrCode_qrCode__P+QgI","qrCodeDark":"QrCode_qrCodeDark__RtFcE","qrCodeLight":"QrCode_qrCodeLight__tlbbE"};